import { Fragment, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FilePageService from "../../API/FilePage/FilePageService";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import Loading from "../../Common/Loading";

const EditMyProduct = (props) => {
  const { t } = useTranslation();

  const {
    showmodal,
    handleModalClose,
    handleEditModalCloseAfterAPICall,
    editId,
    qRBasisList,
    insurerProductList,
    logicalBlockList
  } = props;

  const [flashMessage, setFlashMessage] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const [selectQRBasis, setSelectQRBasis] = useState([]);
  const [selectQuestion, setSelectQuestion] = useState([]);
  const [selectProduct, setSelectProduct] = useState([]);
  const [selectLogicalBlock, setSelectLogicalBlock] = useState([]);
  const [questionsList, setQuestionsList] = useState([]);

  useEffect(() => {
    if (flashMessage.message) {
      const timer = setTimeout(() => {
        setFlashMessage({ type: "", message: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [flashMessage]);

  useEffect(() => {
    if (showmodal && editId) {
      ShowMyProduct(editId);
    }
  }, [showmodal, editId]);

  const QuestionsList = async (qrBasisId, logicalBlockId, initialSelection = []) => {
    try {
      var userData = {
        qr_basis_id: qrBasisId ? qrBasisId : selectQRBasis?.value  ,
        logical_block_id: logicalBlockId ? logicalBlockId : selectLogicalBlock?.value  
      }

      const response = await FilePageService.user_questions_list(userData);

      if (response.data.status) {
        const formatted =
          response.data.questionsList?.map((item) => ({
            label: item.question_text
              .replace(/_/g, " ")
              .replace(/\b\w/g, (char) => char.toUpperCase()),
            value: item.id,
          })) || [];

        const matchedSelected = initialSelection.filter((sel) =>
          formatted.some((opt) => opt.value === sel.value)
        );

        setSelectQuestion(matchedSelected);

        setQuestionsList(formatted);
      } else {
        setQuestionsList([]);
        setSelectQuestion([]);
      }
    } catch (error) {
      console.log(error);
      setQuestionsList([]);
      setSelectQuestion([]);
    }
  };

  const ShowMyProduct = async (productId) => {
    setLoading(true);
    try {
      const response = await FilePageService.my_product_show(productId);

      if (response.data.status) {
        const data = response.data.product;

        const ProductShow = {
          value: data.product && data.product?.id,
          label: data.product && data.product?.name,
        };

        const QRBasesShow = {
          value: data.qr_bases && data.qr_bases?.qr_basis_id,
          label: data.qr_bases && data.qr_bases?.qr_basis_name,
        };

        const LogicalBlockShow = {
          value: data.logical_block && data.logical_block?.id,
          label: data.logical_block && data.logical_block?.name,
        };

        const QuestionBasesShow = data.questions &&
          data.questions.map((question) => ({
            value: question && question?.question_id,
            label: question && question?.question_name,
          })) || [];
        
        setSelectProduct(ProductShow || []);
        setSelectLogicalBlock(LogicalBlockShow || []);
        setSelectQRBasis(QRBasesShow || []);

        if (QRBasesShow?.value || LogicalBlockShow?.value) {
          await QuestionsList(QRBasesShow?.value, LogicalBlockShow?.value, QuestionBasesShow);
        } else {
          setSelectQuestion(QuestionBasesShow);
        }

        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      setFlashMessage({
        type: "error",
        message: t("somethingWentWrong"),
      });
    }
  };

  const EditProduct = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (
      !selectQRBasis?.value ||
      selectQuestion.length === 0 ||
      !selectProduct?.value
    ) {
      setFlashMessage({
        type: "error",
        message: t("requriedErrorMessageLabel"),
      });
      return;
    }

    setLoading(true);

    const payload = {
      product_id: selectProduct?.value,
      qr_basis_ids: selectQRBasis?.value,
      question_ids: selectQuestion.map((q) => q.value),
      logical_block_id: selectLogicalBlock ? selectLogicalBlock.value : ""
    };

    try {
      const response = await FilePageService.my_product_update(editId, payload);

      if (response.data.status) {
        handleEditModalCloseAfterAPICall();
      } else {
        setFlashMessage({
          type: "error",
          message: response.data.message || t("somethingWentWrong"),
        });
      }
    } catch (error) {
      setFlashMessage({
        type: "error",
        message: error.response?.data?.message || t("somethingWentWrong"),
      });
    } finally {
      setLoading(false);
    }
  };

  const QRBasisOptions =
    qRBasisList?.map((item) => ({
      label: item.name
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      value: item.id,
    })) || [];

  const QuestionsOptions = questionsList || [];

  const InsurerProductOptions =
    insurerProductList?.map((item) => ({
      label: item.name
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      value: item.id,
    })) || [];

  const LogicalBlockOptions =
    logicalBlockList?.map((item) => ({
      label: item.name,
      value: item.id,
    })) || [];

  return (
    <Fragment>
      <Modal
        className="missing-doc-modal invalid-doc-modal"
        show={showmodal}
        onHide={handleModalClose}
      >
        <Form onSubmit={EditProduct}>
          <Modal.Header closeButton>
            <Modal.Title>Modifier mon produit</Modal.Title>
          </Modal.Header>
          {loading ? (
            <Loading />
          ) : (
            <>
              <Modal.Body>
                <h2>Modifier mon produit</h2>

                {flashMessage.message && (
                  <div
                    className={`mt-3 mx-w-620 alert ${flashMessage.type === "success"
                      ? "alert-success"
                      : "alert-danger"
                      } text-center`}
                    role="alert"
                  >
                    {flashMessage.message}
                  </div>
                )}
                <div className="mt-3">
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Produits <span>*</span>
                    </Form.Label>
                    <Select
                      options={InsurerProductOptions}
                      value={selectProduct}
                      onChange={(selectedOption) =>
                        setSelectProduct(selectedOption)
                      }
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          width: "100%",
                        }),
                      }}
                      placeholder={"Sélectionnez un produit"}
                      isSearchable={true}
                      noOptionsMessage={() => t("NorecordsfoundLabel")}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>
                      Base QR <span>*</span>
                    </Form.Label>
                    <Select
                      options={QRBasisOptions}
                      value={selectQRBasis}
                      onChange={(selectedOption) => {
                        setSelectQRBasis(selectedOption);
                        if (selectedOption?.value) {
                          QuestionsList(selectedOption.value, "", []);
                        } else {
                          setQuestionsList([]);
                          setSelectQuestion([]);
                        }
                      }}
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          width: "100%",
                        }),
                      }}
                      placeholder={"Sélectionnez la base QR"}
                      isSearchable={true}
                      noOptionsMessage={() => t("NorecordsfoundLabel")}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Bloc logique</Form.Label>
                    <Select
                      options={LogicalBlockOptions}
                      value={selectLogicalBlock}
                      onChange={(selectedOption) => {
                        setSelectLogicalBlock(selectedOption)
                        if (selectedOption?.value) {
                          QuestionsList("", selectedOption.value, []);
                        } else {
                          setQuestionsList([]);
                          setSelectQuestion([]);
                        }
                      }}
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          width: "100%",
                        }),
                      }}
                      placeholder={"Sélectionnez le bloc logique"}
                      isSearchable={true}
                      noOptionsMessage={() => t("NorecordsfoundLabel")}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>
                      Questions <span>*</span>
                    </Form.Label>
                    <MultiSelect
                      options={QuestionsOptions}
                      value={selectQuestion}
                      onChange={(selectedOption) =>
                        setSelectQuestion(selectedOption)
                      }
                      labelledBy="Select questions"
                      overrideStrings={{
                        selectSomeItems: "sélectionner une option",
                        allItemsAreSelected:
                          "Toutes les options sont sélectionnées",
                        selectAll: "Tout sélectionner",
                        search: "Recherche",
                      }}
                    />
                  </Form.Group>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="cancel-btn"
                  variant="primary"
                  onClick={handleModalClose}
                >
                  {t("cancelLabel")}
                </Button>
                <Button variant="primary" type="submit" disabled={loading}>
                  Mise à jour
                </Button>
              </Modal.Footer>
            </>
          )}
        </Form>
      </Modal>
    </Fragment>
  );
};

export default EditMyProduct;